import { getData } from 'util/Api';
import { haveDateLoaded } from 'constants/operations';
import API from 'constants/api';
import { call, put, takeLatest, select, all } from 'redux-saga/effects';
import { actions } from './slice';
import { selectPackagePaquersHistory } from './selectors';

const URL = API.packages.withPaquersHistorical;

function* fetchSaga() {
  try {
    const {
      pageable: { pageNumber, pageSize, totalElements },
      search,
      status,
      type,
      date,
      paquerId,
    } = yield select(selectPackagePaquersHistory);
    const searchParams = new URLSearchParams({
      page: pageNumber,
      size: pageSize,
      total: totalElements,
      desc: true,
      paquerId,
      packageType: type,
      status,
      search,
      type,
      from: date.from,
      to: date.to,
    });
    const packages = yield call(getData, `${URL}?${searchParams.toString()}`);
    const payload = {
      items: packages.content,
      total: packages.totalElements,
    };
    yield put({ type: actions.success.type, payload });
  } catch (error) {
    yield put({ type: actions.failure.type });
  }
}

function* updateBasefilters() {
  const { status, date, paquerId } = yield select(selectPackagePaquersHistory);
  if (status === null || !haveDateLoaded(date) || paquerId === null) {
    return;
  }
  yield put({
    type: actions.fetch.type,
  });
}

export default function* rootSaga() {
  yield all([
    takeLatest(
      [
        actions.updateDate,
        actions.updatePagination,
        actions.updateSearch,
        actions.updatePaquer,
        actions.updateStatus,
        actions.updatePackageType,
        actions.updatePacket,
        actions.refreshPage,
        actions.resetFilters,
      ],
      updateBasefilters,
    ),
    takeLatest([actions.fetch], fetchSaga),
  ]);
}
